import type { FC, ReactNode } from "react";
import { PlainTooltip } from "@similarweb/ui-components";
import type { IntegrationSyncStatus } from "../../types";
import { StyledIntegrationIndicatorContainer, StyledIntegrationText } from "./styles";

export type IntegrationStatusIndicatorProps = {
    tooltipText?: string;
    status: IntegrationSyncStatus;
    statusText: string;
    icon: ReactNode;
    withIcon: boolean;
};

export const IntegrationStatusIndicator: FC<IntegrationStatusIndicatorProps> = (props) => {
    const { tooltipText = "", status, statusText, icon, withIcon } = props;

    return (
        <PlainTooltip
            enabled={!!tooltipText.length}
            tooltipContent={tooltipText}
        >
            <StyledIntegrationIndicatorContainer status={status}>
                {icon}
                <StyledIntegrationText withIcon={withIcon}>{statusText}</StyledIntegrationText>
            </StyledIntegrationIndicatorContainer>
        </PlainTooltip>
    );
};
